import '@unocss/reset/tailwind.css';
import '@vuepic/vue-datepicker/dist/main.css';
import 'floating-vue/dist/style.css';
import 'virtual:uno.css';
import 'vue3-toastify/dist/index.css';
import './style.css';

import { createApp } from 'vue';
import { Api } from './api/api.client';
import App from './App.vue';
import { initLocale } from './composables/useLocale';
import { registerPlugins } from './plugins/plugins';
import { useAppConfigStore } from './stores/useAppConfigStore';
import { useAuthStore } from './stores/useAuthStore';

const app = createApp(App);
registerPlugins(app);

void useAppConfigStore().load();

// resolve the initial locale (URL override > profile > persisted choice > browser > default)
// after the plugins (Pinia, i18n) are registered and before the app renders
initLocale();

const authStore = useAuthStore();
const csrfToken = authStore.csrfToken;
Api.setHeader('x-csrf-token', csrfToken);

app.mount('#app');
